// src/widgets/common/utils/iframeMessaging.js

/**
 * Envoie un message du widget à la page parente
 *
 * @param {string} type - Type de message
 * @param {Object} data - Données à envoyer
 * @param {string} instanceId - ID de l'instance
 * @return {boolean} - Succès de l'envoi
 */
export function sendToParent(type, data = {}, instanceId = 'default-instance') {
  if (!window.parent || window.parent === window) {
    return false;
  }

  const message = {
    type,
    instanceId,
    ...data,
  };

  window.parent.postMessage(message, '*');
  return true;
}

/**
 * Envoie un message de fermeture du modal
 *
 * @param {string} instanceId - ID de l'instance
 * @return {boolean} - Succès de l'envoi
 */
export function sendCloseMessage(instanceId = 'default-instance') {
  return sendToParent('brydge-close-modal', {}, instanceId);
}

/**
 * Envoie un message pour scroller vers le haut de l'iframe
 *
 * @param {string} instanceId - ID de l'instance
 * @return {boolean} - Succès de l'envoi
 */
export function sendScrollToTopMessage(instanceId = 'default-instance') {
  return sendToParent('brydge-scroll-to-top', {}, instanceId);
}

/**
 * Écouteur de messages venant de l'iframe pour le parent
 *
 * @param {Function} handler - Fonction de traitement des messages
 * @param {HTMLIFrameElement} iframe - Élément iframe source
 * @return {Function} - Fonction de nettoyage
 */
export function listenToIframe(handler, iframe) {
  const messageListener = (event) => {
    // Filtrer les messages qui nous intéressent
    if (event.source === iframe.contentWindow) {
      handler(event.data);
    }
  };

  window.addEventListener('message', messageListener);

  // Retourner une fonction de nettoyage
  return () => {
    window.removeEventListener('message', messageListener);
  };
}
